import { reduceAction } from '@elab/core/store/helpers';

import types from './types';

export const initialState = () => ({
    storedAddressId: '',
    addresses: [],
    defaultAddressId: '',
});

const reducers = (state = initialState(), { type, payload }) => {
    switch (type) {
        case types.SET_STORED_ADDRESS_ID:
            return reduceAction(state, 'storedAddressId', payload);

        case types.SET_ADDRESSES:
            return {
                ...state,
                addresses: [...payload.addresses],
                defaultAddressId: payload.defaultAddressId,
                storedAddressId: payload.defaultAddressId,
            };
        default:
            return state;
    }
};

export default reducers;
